module.exports = __webpack_public_path__ + "img/高校院所.09bf5630.png";